<template>
  <div class="card-list-wrapper">
    <div class="card-list">
      <v-card v-for="user in items" :key="user._id">
        <v-card-title>{{ user.name }}</v-card-title>
        <v-card-actions>
          <v-btn icon title="remover" @click="deteleAction(user)">
            <v-icon>remove</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: Array,
  },
  methods: {
    deteleAction(user) {
      this.$emit('delete-action', { id: user._id, name: user.name });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';

.card-list-wrapper {
  width: 100%;

  .card-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px 16px;
    margin: 72px auto 40px auto;
    box-sizing: border-box;

    .v-card {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .v-card__title {
        font-size: 1.2rem;
        font-weight: 300;
      }
    }

    @include for-size(phone-only) {
      display: block;
      width: 100%;
      padding: 16px;
      margin: 56px auto 0 auto;
      box-sizing: border-box;
    }
  }
}
</style>
